import { Box, FormControl, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RootineButton from '../../../atoms/RootineButton';
import { useAlgoInputs, useRunAlgo } from '../../../config/api/queries';
import { AlgoInputs } from './AlgoInputs';
import { AlgoOutputs } from './AlgoOutputs';

export const AlgorithmView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = useState<string>(searchParams.get('email') || '');
  const algoInputs = useAlgoInputs();
  const runAlgo = useRunAlgo();

  const handleSearch = async (email: string) => {
    if (!email) {
      return;
    }
    runAlgo.reset();
    algoInputs.mutate({ email });
    setSearchParams({ email });
  };

  const handleRunAlgo = async () => {
    if (!algoInputs.data) {
      return;
    }
    runAlgo.mutate(algoInputs.data);
  };

  useEffect(() => {
    const e = searchParams.get('email');
    if (e) {
      handleSearch(e);
    }
  }, []);

  return (
    <Grid
      container
      sx={{
        width: '100%',
        height: '100%',
        minWidth: '80vw',
      }}
    >
      <Grid item xs={12} paddingBottom={2}>
        <FormControl
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <TextField
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              error={algoInputs.isError}
              value={email}
              placeholder={"Enter user's email"}
              disabled={algoInputs.isLoading}
              sx={{
                width: '100%',
                mr: 2,
              }}
            />
            <RootineButton
              label="Search"
              variation="outline_dark"
              size="medium"
              onClick={() => {
                handleSearch(email);
              }}
              disabled={!email}
            />
          </Box>
          <RootineButton
            label={`Run Algo`}
            variation="outline_dark"
            size="medium"
            onClick={() => {
              handleRunAlgo();
            }}
            disabled={!algoInputs.data}
            sx={{
              width: '100%',
              mt: 2,
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <AlgoInputs email={email} input={algoInputs.data} />
      </Grid>
      <Grid item xs={6}>
        <AlgoOutputs output={runAlgo.data} />
      </Grid>
    </Grid>
  );
};
